import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=6b046b41&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=6b046b41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b046b41",
  null
  
)

export default component.exports